<div class="content-width">
    <div class="logo-bar">
        <div class="main-logo">
            <a (click)="logoClicked()">
                <img class="logo" src="{{brandLogo}}" height="75">  </a>
        </div>
        <div class="bar-container">

            <div class="top-profile-bar bar-item">
                <div class="bar-item" *ngIf="isAuthenticated && currentUser && !isPreLogin">
                    <body-text>

                        <ul class="m-0 p-0">
                            <li ngbDropdown class="nav-item">
                                <a class="nav-link dropdown-toggle" id="log" ngbDropdownToggle>
                                    <fa-icon [icon]="faUser"></fa-icon> {{currentUser.Firstname+ ' ' +
                                    currentUser.Lastname}}<strong>{{isImpersonate?'(Impersonated)':''}}</strong>

                                </a>
                                <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="log">
                                    <a ngbDropdownItem class="c-pointer" [class.active]=" " href="javascript:void(0);"
                                        (click)="changeSecurityQuestion()"
                                        translate="UserMenu.ChangeSecurityQuestion"></a>
                                    <a ngbDropdownItem class="c-pointer" [class.active]=" " href="javascript:void(0);"
                                        (click)="changePassword()" translate="UserMenu.ChangePassword"></a>
                                    <a ngbDropdownItem class="c-pointer" href="javascript:void(0);"
                                        (click)="editProfile()" translate="UserMenu.ViewMyProfile"></a>
                                    <a ngbDropdownItem class="c-pointer logout-border-top" href="javascript:void(0);"
                                        (click)="logout()" *ngIf="isAuthenticated && currentUser && !isPreLogin"
                                        translate="UserMenu.LogOut"></a>
                                </div>
                            </li>
                        </ul>
                    </body-text>
                </div>
                <div class="logout">
                    <ul class="m-0 p-0">
                        <li ngbDropdown class="nav-item">
                            <a class="nav-link dropdown-toggle" id="dropdownCulture" ngbDropdownToggle>
                                <fa-icon [icon]="faGlobeAmericas"></fa-icon>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu
                                aria-labelledby="dropdownCulture">
                                <a ngbDropdownItem class="c-pointer"
                                    [class.active]="selectedCulture==language.languageCulture"
                                    *ngFor="let language of systemSettings.platformLanguages"
                                    (click)="changeLanguage(language.languageCulture)">
                                    {{language.languageName}}
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
                <!--   <img class="logo" src="assets/images/biw-full.png"> -->

            </div>
        </div>
    </div>